// Kleiner Client-Cache für den Kundenstamm (#35 Stufe 1).
// Tickets tragen nur customerId; für die Anzeige der Kurzform wird die
// Kundenliste einmal geladen und 60 s gehalten (der Stamm ändert sich selten).
import apiService from '../services/apiService';
import { getFeatures } from './featuresCache';

const TTL_MS = 60 * 1000;
let cache = null; // Map<id, {id, name, shortName, domains}>
let fetchedAt = 0;
let pending = null;

async function loadCustomers() {
  if (cache && Date.now() - fetchedAt < TTL_MS) return cache;
  if (!pending) {
    pending = apiService.getCustomers()
      .then(resp => {
        cache = new Map((resp.customers || []).map(c => [c.id, c]));
        fetchedAt = Date.now();
        return cache;
      })
      .catch(() => cache || new Map())
      .finally(() => { pending = null; });
  }
  return pending;
}

// Liefert die Anzeige-Kurzform zu einer customerId oder null.
export async function getCustomerLabel(customerId) {
  if (!customerId) return null;
  const map = await loadCustomers();
  const c = map.get(customerId);
  return c ? (c.shortName || c.name) : null;
}

// Liste für Auswahl-UIs (#35 Stufe 2, CustomerSelect): [{ value, label }],
// alphabetisch nach Anzeige-Label.
export async function getCustomerOptions() {
  const map = await loadCustomers();
  return Array.from(map.values())
    .map(c => ({ value: c.id, label: c.shortName || c.name }))
    .sort((a, b) => String(a.label).localeCompare(String(b.label), 'de'));
}

// #210: Client-Seite der deterministischen Domänen-Zuordnung (Server-Pendant:
// services/customerService.js findCustomerIdByEmail) — belegt das Kundenfeld
// in den Anlage-Dialogen vor. Nutzt dieselben Domänen, die GET /api/customers
// ausliefert (nur aktive Kunden). Liefert customers.id oder null.
export async function findCustomerIdByEmail(address) {
  try {
    if (!address) return null;
    // wie der Server (isCustomersEnabled): Feature aus = keine Zuordnung
    const features = await getFeatures();
    if (features.customers === false) return null;
    let d = String(address).trim().toLowerCase();
    const at = d.lastIndexOf('@');
    if (at >= 0) d = d.slice(at + 1);
    d = d.replace(/[>\s]+$/g, '').replace(/^[<\s]+/g, '');
    if (!d || !/^[a-z0-9.-]+\.[a-z]{2,}$/.test(d)) return null;
    const map = await loadCustomers();
    for (const c of map.values()) {
      if ((c.domains || []).some(dom => String(dom).toLowerCase() === d)) return c.id;
    }
    return null;
  } catch (_) {
    return null;
  }
}

export function invalidateCustomerCache() {
  cache = null;
  fetchedAt = 0;
}
